import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { Button } from '@basic';
import { UIPaths } from '@consts';
import PlaceholderCatIcon from './PlaceholderCatIcon';
import PlaceholderContainer from './PlaceholderContainer';
import PlaceholderHeader from './PlaceholderHeader';
import PlaceholderText from './PlaceholderText';

function ErrorNotFoundPlaceholder() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <PlaceholderContainer data-testid='error-not-found-placeholder'>
      <PlaceholderCatIcon />
      <PlaceholderHeader text={t('components.errorNotFoundPlaceholder.header')} />
      <PlaceholderText text={t('components.errorNotFoundPlaceholder.text')} />
      <Button size='large' type='tertiary' onClick={() => router.push(UIPaths.home())}>
        <div className='flex flex-row items-center justify-center gap-xs'>
          <div>{t('components.errorNotFoundPlaceholder.backToHomeButton.text')}</div>
        </div>
      </Button>
    </PlaceholderContainer>
  );
}

export default ErrorNotFoundPlaceholder;
